/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteDomainSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteDomainRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteDomainSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteDomainSecurity$outboundSchema: z.ZodMiniType<
  DeleteDomainSecurity$Outbound,
  DeleteDomainSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteDomainSecurityToJSON(
  deleteDomainSecurity: DeleteDomainSecurity,
): string {
  return JSON.stringify(
    DeleteDomainSecurity$outboundSchema.parse(deleteDomainSecurity),
  );
}

/** @internal */
export type DeleteDomainRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteDomainRequest$outboundSchema: z.ZodMiniType<
  DeleteDomainRequest$Outbound,
  DeleteDomainRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteDomainRequestToJSON(
  deleteDomainRequest: DeleteDomainRequest,
): string {
  return JSON.stringify(
    DeleteDomainRequest$outboundSchema.parse(deleteDomainRequest),
  );
}
